<template>
    <span
        ref="time"
        class="me-3"
    ></span>
</template>
<script setup lang="ts">
import { onActivated, onDeactivated, onMounted, ref } from 'vue';

const props = defineProps<{
    /**
     * If we should show HH:MM:SS format
     */
    use24HourFormat?: boolean;

    /**
     * if we should show milliseconds
     */
    useMilliseconds?: boolean;
}>();

// Ref the element
const time = ref<HTMLElement | null>(null);

let intervalId: number | null = null;

/**
 * Set the default time
 */
const setTime = () => {
    if (time.value) {
        if (props.use24HourFormat === true) {
            // We only want to use the timepart of the timestring
            const now = new Date();
            const hour = now.getHours();
            const minute = now.getMinutes();
            const second = now.getSeconds();
            const fractional = now.getMilliseconds();
            time.value.innerText = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}.${fractional.toString().substring(0, 1)}`;
        } else {
            time.value.innerText = new Date().toLocaleTimeString();
        }
    }
};

const startTimer = () => {
    if (intervalId) {
        window.clearInterval(intervalId);
    }
    setTime();
    intervalId = window.setInterval(() => setTime(), props.useMilliseconds === true ? 100 : 500);
};

/**
 * We start a new timer when the component is activated
 */
onActivated(() => {
    startTimer();
});

/**
 * We clear the timer when the component is deactivated
 */
onDeactivated(() => {
    if (intervalId) {
        window.clearInterval(intervalId);
    }
});

onMounted(() => {
    startTimer();
});
</script>
